var contact = function (scope) {
  // Send an email on form submit

  $("#contact_form").on("submit", function (evt) {
    // Get the form
    var $F = $(this);
    // Get the submit button
    var submitButton = $F.find('input[type="submit"]').eq(0);
    // If the form contain a phone number, get the full phone number
    if ($("#f-phone-number").length) {
      $('input[name="phone-number"]', $F).val(
        $("#f-phone-number").intlTelInput("getNumber")
      );
    }
    // If we have a subject selector with a "Other" option and this option is selected
    // We check if the custom subject is empty or not
    if (
      $("#f-custom-subject").length &&
      !$("#f-custom-subject").prop("disabled")
    ) {
      if (!$("#f-custom-subject").val().trim()) {
        scope.topbar.notify(
          gettext("Subject input empty. Enter a subject to send you request."),
          "error"
        );
        return false;
      }
    }
    // If the textarea message is required check if it's empty or not
    if ($("#f-message").length && $("#f-message").prop("required")) {
      if (!$("#f-message").val().trim()) {
        scope.topbar.notify(
          gettext("Message input empty. Enter a message to send you request."),
          "error"
        );
        return false;
      }
    }
    //console.log($F.serialize()); // Debug

    // Disable all elements until the end
    $F.find("input").each(function () {
      $(this).addClass("disabled");
    });
    $F.find("textarea").each(function () {
      $(this).addClass("disabled");
    });
    submitButton.prop("value", gettext("SENDING ..."));
    $.ajax(contactUrl, {
      method: "POST",
      data: $F.serialize(),
    })
      .done(function (data) {
        // Reset current form
        $F[0].reset();
        // Do some style operations
        submitButton.addClass("disabled");
        submitButton.removeClass("button-action");
        submitButton.addClass("button-normal");
        submitButton.prop("value", gettext("MESSAGE SENT!"));
        // Show topbar notification
        scope.topbar.notify(
          gettext(
            "Your request has been sent successfully. We will contact you as soon as possible."
          ),
          "success"
        );
      })
      .error(function (jqXHR) {
        if (jqXHR.responseJSON && jqXHR.responseJSON.error) {
          scope.topbar.notify(jqXHR.responseJSON.error, "error");
        } else {
          console.error(jqXHR.responseJSON);
        }
        // If failed enable back all elements
        submitButton.prop("value", gettext("SEND"));
        $F.find("input").each(function () {
          $(this).removeClass("disabled");
        });
        $F.find("textarea").each(function () {
          $(this).removeClass("disabled");
        });
      });
    return false;
  });
};
